import React, { useState, useEffect } from 'react';
import { Container, ListGroup, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import moment from 'moment';
import api from '../../services/api';
import './NoticesSection.css';

const NoticesSection = ({ section }) => {
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadNotices();
  }, []);

  const loadNotices = async () => {
    try {
      const response = await api.get('/notices/', { params: { page_size: 5 } });
      setNotices(response.data.results || response.data);
    } catch (error) {
      console.error('Error loading notices:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section className="notices-section homepage-section">
        <Container>
          <h2 className="section-title">{section.title}</h2>
          <div className="text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </Container>
      </section>
    );
  }

  if (notices.length === 0) return null;

  return (
    <section className="notices-section homepage-section">
      <Container>
        <h2 className="section-title">{section.title}</h2>
        <ListGroup>
          {notices.map(notice => (
            <ListGroup.Item key={notice.id} className="notice-item">
              <div className="d-flex justify-content-between align-items-start flex-wrap">
                <div className="flex-grow-1">
                  <Link to={`/notices/${notice.slug}`} className="notice-title">
                    {notice.title}
                  </Link>
                  <div className="notice-meta">
                    <Badge bg="primary">{notice.notice_type}</Badge>
                    {notice.is_new && <Badge bg="danger">New</Badge>}
                    <span className="text-muted small">
                      <i className="far fa-calendar-alt me-1"></i>
                      {moment(notice.published_date).format('MMM DD, YYYY')}
                    </span>
                  </div>
                </div>
              </div>
            </ListGroup.Item>
          ))}
        </ListGroup>
        <div className="text-center mt-4">
          <Link to="/notices" className="btn btn-primary">
            View All Notices <i className="fas fa-arrow-right ms-2"></i>
          </Link>
        </div>
      </Container>
    </section>
  );
};

export default NoticesSection;
